module.exports = __webpack_public_path__ + "img/badge-list-thumb-012.c141fe6b.png";